import { Col } from 'antd';
import { FormItem } from 'modules/common/components';
import GroupSelect from 'modules/donor/components/GroupSelect';
import { ComponentProps, FC } from 'react';
import { Control, FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

import { CreateAppointmentValidationSchema } from '../../CreateAppointmentsModal/schema';
import { AppointmentFormField } from '../fields';

type PropTypes = {
  control: Control<CreateAppointmentValidationSchema, any>;
  canAddDonorToAppointment?: boolean;
  showClearButtonByDefault?: boolean;
} & ComponentProps<typeof FormItem>;

const FIELD_NAME = AppointmentFormField.SelectedGroup;

const GroupSelectField: FC<PropTypes> = ({
  canAddDonorToAppointment,
  showClearButtonByDefault,
  control,
  ...restFormItemProps
}) => {
  const { t } = useTranslation('appointments.CreateAppointmentsFormFields');
  const fieldState = control.getFieldState(FIELD_NAME);
  const error = fieldState.error as unknown as FieldError | undefined;

  return (
    <Col span={24}>
      <FormItem
        colon
        className={styles.formItem}
        label={t('group')}
        extra={error?.message}
        validateStatus={error?.message && 'error'}
        {...restFormItemProps}
      >
        <GroupSelect
          showClearButtonByDefault={showClearButtonByDefault}
          allowClear
          controlled={{ control, name: FIELD_NAME }}
        />
      </FormItem>
    </Col>
  );
};

export default GroupSelectField;
